import angular, {
  ICompileService,
  IDirective,
  ITemplateCacheService,
  ITemplateLinkingFunction,
} from "angular";
import { ProcessDetailViewController } from "../controller";

export const vsDirectiveName = "workflowItemRecursive";

type LinkingFunctionCache = {
  [type: string]: ITemplateLinkingFunction | undefined;
};

export function workflowItemRecursiveDirective(
  $templateCache: ITemplateCacheService,
  $compile: ICompileService
): IDirective {
  const linkingFunctions: LinkingFunctionCache = {};

  return {
    template: `
        <div>
            <label>{{workflowItem.Text}}</label>
            <workflow-item-wrapper state-controller="stateController" workflow-item="workflowItem"></workflow-item-wrapper>
            <div ng-if="workflowItem.Children && workflowItem.Children.length > 0">
              <workflow-item-recursive ng-repeat="childItem in workflowItem.Children" workflow-item="childItem" state-controller="stateController"></workflow-item-recursive>
            </div>
        </div>
    `,
    scope: {
      workflowItem: "=",
      stateController: "=",
    },
  };
}
workflowItemRecursiveDirective.$inject = ["$templateCache", "$compile"];
